// @ts-check

/** @typedef {import("./game_lists/GameList").GameListType} GameListType */
/** @typedef {import(".").BuildConfiguration} BuildConfiguration */
import { DEV_URL } from "./Constants";
import { ReturnFrontendParametersString, checkIfMobile } from "./Parameters";
import { findGame } from "./Utils";
import { captureSampleError } from "./Sentry";
import { isCorrectStageValue } from "./game_lists/GameList";

/**
 * @typedef {Object} BuildUrls
 * @property {string=} development
 * @property {string} online
 * @property {string} onlineSelective
 * @property {string} e2Web
 * @property {string} e2Mobile
 */
// type BuildUrls = {
//     development?: string;
//     online: string;
//     onlineSelective: string;
//     e2Web: string;
//     e2Mobile: string;
// };

/** 
 * @type {Readonly<BuildUrls>} 
*/
const buildUrlsDev = {
    development: DEV_URL + "builds/engin3/development/web/latest/",
    online: DEV_URL + "online/",
    onlineSelective: DEV_URL + "onlineSelective/",
    e2Web: "https://gs-client.testowaplatforma123.net/online/development/demo/single_run/game.html",
    e2Mobile: "https://gs-client.testowaplatforma123.net/online/development/demo_mobile/single_run/game.html",
};

export const noStageError = new Error("No stage param has been set");
/**
 * 
 * @param {URL} url 
 * @param {GameListType} gameList 
 * @param {BuildConfiguration} buildConfiguration 
 * @returns {string}
 */
export function redirectUrl(url, gameList, buildConfiguration) {
    console.log(url, "url")

    //awful hack for old gs, TODO: delete when backend updates gs on frozen envs
    //hack for old gs, check tests
    if (url.searchParams.get("stage") && url.searchParams.get("stage")?.split("?").length === 2 && ["staging", "stage1", "stage2", "stage3", "stage4"].includes(/** @type {string} */(url.searchParams.get("stage")).split("?")[0])) {
        captureSampleError("Old gs hack - stage", 0.01);
        return url.origin + url.pathname + "?" + url.search.replace("?", "").replace("?", "&");
    }

    //second hack for old gs, check tests, please let me out
    if (url.searchParams.get("hackRulesMaxWinningsCap")?.split("?").length === 2 && url.searchParams.get("hackRulesMaxWinningsCap")?.split("?")[0] === "true") {
        captureSampleError("Old gs hack - hackRulesMaxWinningsCap", 0.01);
        return url.origin + url.pathname + "?" + url.search.replace("?", "").replace("?", "&");
    }

    //third hack for old gs, check tests, please let me out
    if (url.searchParams.get("showMaxHourlyLossRules")?.split("?").length === 2 && url.searchParams.get("showMaxHourlyLossRules")?.split("?")[0] === "true") {
        captureSampleError("Old gs hack - showMaxHourlyLossRules", 0.01);
        return url.origin + url.pathname + "?" + url.search.replace("?", "").replace("?", "&");
    }


    //gennerally awful hack for new jackpots, will be deleted later, when we fix jackpots on backend too
    if (url.searchParams.get("gameUrl")) { //https://beefee.slack.com/archives/C05FDRJ2878/p1700041158277549
        return hackRedirectWhenJackpotsEnabled(url)
    }

    const gameId = url.searchParams.get("gameId")
    if (!gameId) {
        throw new Error("URL is missing gameId param");
    }
    let game = findGame(gameId, gameList);

    const brandedGameVersion = findGame(url.searchParams.get("gameId") + "-" + url.searchParams.get("operatorId"), gameList);
    if (url.searchParams.get("addOperatorIdToGameId") === "true" && brandedGameVersion) {
        url.searchParams.set("gameId", brandedGameVersion.id)
        game = brandedGameVersion
    }

    if (!game) {
        throw new Error("Game not added to gamelist: " + url.searchParams.get("gameId"));
    }


    const stageParam = url.searchParams.get("stage");
    const forceCustomBuildParam = url.searchParams.get("forceCustomBuild");

    if (!stageParam) {
        throw noStageError;
    }

    if (!isCorrectStageValue(stageParam)) {
        throw new Error("unallowed value for stage param: " + stageParam)
    }

    /** @type {BuildUrls} */
    let buildOrigin;
    if (url.href.includes(DEV_URL) || /** @type {string} */ (stageParam) === "development") {
        buildOrigin = buildUrlsDev;
    } else {
        buildOrigin = {
            online: url.origin + "/online/",
            onlineSelective: url.origin + "/onlineSelective/",
            e2Web: "https://static-prod.beefee.co.uk/e2-web/single_run/game.html",
            e2Mobile: "https://static-prod.beefee.co.uk/e2-mobile/single_run/game.html",
        };
    }

    let buildType = game[stageParam]
    //overwrite path to development with e2 if this is an e2 game, TODO: DELETE ONCE E2 IS NO LONGER USED
    if (game["staging"] === "e2" && /** @type {string} */ (stageParam) === "development") {
        buildType = "e2"
    }

    console.log(buildOrigin, buildType)

    const inputParams = url.search;
    console.log("input url params:\n", inputParams);
    let outputParams = ReturnFrontendParametersString(url.searchParams, buildType === "e2" ? "e2" : "e3", gameList);
    console.log("output url params:\n", outputParams);

    let newUrl = "";
    if (buildType === "online" || buildType === "onlineSelective") {
        const buildNumber = buildConfiguration[buildType][stageParam]
        newUrl += buildOrigin[buildType] + buildNumber + "/";
    } else if (buildType === "e2") {
        newUrl += checkIfMobile() ? buildOrigin.e2Mobile : buildOrigin.e2Web;
    } else if (/** @type {string} */ (stageParam) === "development" || buildType === "development") {
        newUrl += buildUrlsDev.development
    }

    if (forceCustomBuildParam) {
        console.warn("Overwriting build URL with: ", forceCustomBuildParam)
        newUrl = forceCustomBuildParam;
    }
    newUrl += "?" + outputParams;
    console.log("Returning URL: ", newUrl)
    return newUrl;
}

/**
 * 
 * @param {URL} url 
 * @returns {string}
 */
function hackRedirectWhenJackpotsEnabled(url) {
    console.log(url.searchParams.get("sessionId"), "SESSION ID")
    const rules = url.searchParams.get("jackpotRulesTemplateUrl")
    const rulesUrl = url.searchParams.get("jackpotRulesUrl")
    const extraRulesUrl = url.searchParams.get("jackpotExtraRulesUrl")
    const gameUrl = url.searchParams.get("gameUrl")
    if (!gameUrl) throw new Error("missing gameUrl parameter")
    return atob(gameUrl) + "&jackpotRulesTemplateUrl=" + rules + "&jackpotRulesUrl=" + rulesUrl + "&jackpotExtraRulesUrl=" + extraRulesUrl;
}